import { render, staticRenderFns } from "./CampaignAnalytics.vue?vue&type=template&id=f728e856&scoped=true&"
import script from "./CampaignAnalytics.vue?vue&type=script&lang=js&"
export * from "./CampaignAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f728e856",
  null
  
)

export default component.exports